import { render, staticRenderFns } from "./ChallengeResourcePackageDetail.vue?vue&type=template&id=4cec3f6c&scoped=true"
import script from "./ChallengeResourcePackageDetail.vue?vue&type=script&lang=js"
export * from "./ChallengeResourcePackageDetail.vue?vue&type=script&lang=js"
import style0 from "./ChallengeResourcePackageDetail.vue?vue&type=style&index=0&id=4cec3f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec3f6c",
  null
  
)

export default component.exports